import React, { useEffect, useMemo, useState } from 'react'
import styles
  from 'components/Filters/FilterPanel/subcomponents/SubButtons/subbuttons.module.scss'
import { DatePickerCalendar, Popover, Typography } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import format from 'utils/dateFns/format'
import { parse } from 'date-fns'
import { useSelector } from 'react-redux'
import locales from 'utils/dateFns/locales'

const Datepicker = ({ filterManager, filterKey, breakpoints }) => {
  const { i18n } = useSelector(({ app }) => app)
  const { t } = useTranslation()
  const { filters, configuration, updateFilter } = filterManager
  const { bindTrigger, bindPopover, usePopupState } = Popover.usePopover()
  
  const [start, end] = useMemo(
    () => configuration?.[filterKey].names || [],
    [configuration, filterKey, i18n],
  )
  
  const [phrase, setPhrase] = useState(t('common::select_value'))
  
  const popoverState = usePopupState({
    variant: 'popover',
    id: 'selector-popover-' + filterKey,
    breakpoints: {
      0: {
        variant: 'bottomSheet',
        hasBackdrop: true,
        showLabel: true,
      },
      960: {
        variant: 'popover',
        hasBackdrop: false,
      },
    },
  })
  
  useEffect(() => {
    if (!!filters && filters?.[start] && filters?.[end]) {
      setPhrase(
        format(
          parse(filters[start], 'yyyy-MM-dd', new Date()),
          'dd MMM yyyy',
        ).replace('.', '') +
        ' — ' +
        format(
          parse(filters[end], 'yyyy-MM-dd', new Date()),
          'dd MMM yyyy',
        ).replace('.', ''),
      )
    } else {
      setPhrase(t('common::select_value'))
    }
  }, [filterManager.filters, i18n, t])
  
  useEffect(() => {
    !breakpoints.md && popoverState.close()
  }, [breakpoints])
  
  
  return (
    <>
      <div
        className={styles['subbuttons-filter']}
        key={'applied-filter-' + filterKey}
      >
        <Typography
          variant={'Body-15'}
          {...(breakpoints.md ? bindTrigger(popoverState) : {})}
        >
          {t(configuration[filterKey].label)}: {phrase}
        </Typography>
      </div>
      
      <Popover
        {...bindPopover(popoverState)}
        hasBackdrop
        bodyClassName={styles['subbuttons-filter__popover-inner']}
      >
        <DatePickerCalendar
          locale={locales[i18n]}
          months={breakpoints.sm ? 1 : 2}
          minDate={new Date(2018, 0, 1)}
          maxDate={new Date()}
          buttonLabels={{
            dropSelection: t('common::button_labels.drop_selection'),
            applySelection: t('common::button_labels.apply'),
          }}
          value={
            !filters
              ? undefined
              : {
                startDate: filters[start] ? parse(filters[start], 'yyyy-MM-dd', new Date()) : undefined,
                endDate: filters[end] ? parse(filters[end], 'yyyy-MM-dd', new Date()) : undefined,
                key: 'selection',
              }
          }
          onApply={(newValue) => {
            updateFilter([
              {
                fieldName: start,
                value: format(newValue.startDate, 'yyyy-MM-dd'),
              },
              {
                fieldName: end,
                value: format(newValue.endDate, 'yyyy-MM-dd'),
              },
            ])
            
            popoverState.close()
          }}
        />
      </Popover>
    </>
  )
}

Datepicker.propTypes = {
  filterManager: PropTypes.object,
  filterKey: PropTypes.string,
  breakpoints: PropTypes.object,
}

export default Datepicker
